import { LegacyRef } from "react";

export default class BaseModel {
    public ref?: LegacyRef<any>;

    public constructor() {}
}